import  './styles.css';

const LoadingLogin= () =>{
 
    return(
        <div className='container-loading'>
        <div  className='wrapper'>
            <div className='circle'></div>
            <div className='circle'></div>
            <div className='circle'></div>
       
        </div>
        </div>
       

    )
   

}

export default LoadingLogin;